export const pageEvent = {
    // ロード完了したとき（AJAX一覧取得完了）
    loadDone: function (results) {
        $(".js-ajax").html(results["template"]);
        $(".js-event-list-content").hide().fadeIn(300);

        modalWindow.enableButton();
        pageEvent.enableButtons();
        pageEvent.enableAddButton();
    },

    // 一覧を再取得して再描画
    reload: function () {
        post.postAjaxData("/nursery/event", new FormData(), "", pageEvent.loadDone, null, null);
    },

    // ボタンを有効にする
    enableButtons: function () {
        // 削除ボタンが押された
        $(".js-btn-event-delete")
            .off("click")
            .on("click", function () {
                const deleteTargetId = $(this).data("id");
                $(".js-event-delete-execute").data("deleteTargetId", deleteTargetId);
                modalWindow.showModal("#js-modal-event-delete");
            });

        // 削除確認OKボタンが押されたとき
        $(".js-event-delete-execute")
            .off("click")
            .on("click", function () {
                const paramList = new FormData();
                paramList.append("id", $(this).data("deleteTargetId"));

                post.postAjaxData("/nursery/event/delete", paramList, "削除しました", pageEvent.deleteDone, null, null);
            });

        // 編集ボタンが押されたとき
        $(".js-btn-event-edit")
            .off("click")
            .on("click", function () {
                const paramList = new FormData();
                paramList.append("id", $(this).data("id"));
                post.postAjaxData("/nursery/event/showForm", paramList, "", pageEvent.updateLoadDone, null, null);
            });

        // 追加ボタンが押されたとき
        $(".js-btn-event-add")
            .off("click")
            .on("click", function () {
                post.postAjaxData("/nursery/event/showForm", new FormData(), "", pageEvent.updateLoadDone, null, null);
            });

        // 上下移動ボタンが押されたとき
        $(".button-sort")
            .off("click")
            .on("click", function () {
                if ($(this).hasClass("button-sort--up")) {
                    const insert = $(this)
                        .parents(".nursery-event__list-container")
                        .prev(".nursery-event__list-container");
                    if (insert.length) {
                        const targetObject = $(this).parents(".nursery-event__list-container");
                        insert.insertAfter(targetObject);
                    }
                } else {
                    const insert = $(this)
                        .parents(".nursery-event__list-container")
                        .next(".nursery-event__list-container");
                    if (insert.length) {
                        const targetObject = $(this).parents(".nursery-event__list-container");
                        insert.insertBefore(targetObject);
                    }
                }

                pageEvent.updatePosition("移動が完了しました");
            });
    },

    // 追加ボタンの表示制御（5件で非表示）
    enableAddButton: function () {
        if ($(".nursery-event__list-container").length >= 5) {
            $(".nursery-event__list-container--add").hide();
        } else {
            $(".nursery-event__list-container--add").show();
        }
    },

    // 並び替えAPIを呼ぶ
    updatePosition: function (message) {
        let position = 1;
        const paramList = new FormData();
        $(".nursery-event__list-container").each(function () {
            paramList.append("id[" + position + "]", $(this).data("event-id"));
            position++;
        });
        post.postAjaxData("/nursery/event/updatePosition", paramList, message, null, null, null);
    },

    // 編集モーダルのテンプレートが返ってきたとき
    updateLoadDone: function (results) {
        $("#js-event-modal-area").html(results["template"]);
        modalWindow.showModal("#js-modal-event-edit");

        modalWindow.enableButton();
        pageEvent.enableButtons();
        pageEvent.setGuideTypeDisplay();

        imagePreview.preview(".nursery-event__modal-right", ".nursery-event__modal-pict");

        // 画像削除ボタン
        $(".js-event-image-delete")
            .off("click")
            .on("click", function () {
                imagePreview.deleteImage(".nursery-event__modal-pict");
            });

        // 保存ボタン
        $(".js-event-update-button")
            .off("click")
            .on("click", function () {
                form.disableButtons(this);
                const url = $("#eventForm").attr("action");
                form.post(url, "#eventForm", "保存しました", function () {
                    modalWindow.hideModal("#js-modal-event-edit");
                    pageEvent.reload();
                });
            });
    },

    // 案内方法ラジオボタンの切替でイベント内容/外部URLフィールドを表示制御
    setGuideTypeDisplay: function () {
        const toggleFields = function () {
            const guideType = $("input[name='guide_type']:checked").val();
            if (guideType === "1") {
                $(".js-field-content").show();
                $(".js-field-link-url").hide();
            } else {
                $(".js-field-content").hide();
                $(".js-field-link-url").show();
            }
        };

        $(".js-guide-type-radio").off("change").on("change", toggleFields);
    },

    // 削除完了
    deleteDone: function () {
        modalWindow.hideModal("#js-modal-event-delete");
        pageEvent.reload();
    }
};
